<template>
  <div class="card-number">
    {{ index + 1 }}
  </div>
</template>


<script>
export default {
  props: {
    index: {
      type: Number
    }
  }
}
</script>

<style lang="scss" scoped>
@import './_style.scss';
.card-number {
  @include cell;
}
</style>
